import React from 'react';
import iWillLogoWhite from '../../assets/iWillLogoWhite.png';
import { Link, useLocation } from 'react-router-dom';
import { Icon, Icons } from 'components/Icon';
import { useTabFilter } from 'common/hooks/useTabFilter';
import { userNavs } from 'constants/nav';
import { IUserNav } from 'types/INav.type';
import { determinePathName } from 'utils';
import { useAppSelector } from 'store/hooks';
import { selectAccountDetails } from 'selectors/account-selector';

type Props = {
  show: boolean;
  setShow: () => void;
};
export default function SideBar({ show, setShow }: Readonly<Props>) {
  const { pathname } = useLocation();
  const { user } = useAppSelector(selectAccountDetails);
  const pendingPage = user && JSON.parse(user.pendingPage);

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-40 w-[15rem] ${
        !show
          ? '-translate-x-full sm:translate-x-0 md:relative md:-translate-x-0 '
          : ''
      } space-y-6 bg-[#121638] transition duration-200 ease-in-out `}
      aria-label="Sidebar"
    >
      <div className="h-screen overflow-y-auto bg-[#121638] pb-10">
        <div className="sticky top-0 z-50 flex bg-[#121638] pl-[34px] pt-[30px]">
          <div className="flex w-full items-center justify-between">
            <Link
              to="/dashboard"
              className="m-4 ml-5 flex items-center justify-center self-center md:mr-24"
              onClick={setShow}
            >
              <img src={iWillLogoWhite} className="h-12 md:ml-8" alt="Logo" />
            </Link>
            <button
              className="mr-2 flex justify-end md:hidden"
              onClick={setShow}
            >
              <Icon name={Icons.Close} fill="#FFFFFF" />
            </button>
          </div>
        </div>
        <div className="z-50 h-[calc(100%-80px)] overflow-y-auto bg-[#121638] py-2 scrollbar-hide">
          <ul className="mt-10 space-y-3">
            {useTabFilter(userNavs).map((item: IUserNav) => (
              <li
                key={item.path}
                className={`px-4 text-sm ${
                  determinePathName(pathname) === item.main
                    ? 'border-l-4 border-[#FFFFFF] bg-gradient-to-r from-[#FF6600] font-semibold'
                    : 'font-normal hover:bg-gray-700'
                } `}
              >
                <Link
                  to={item.path}
                  className="group flex items-center rounded-lg p-2 text-white"
                  onClick={e => {
                    if (
                      !user.onBoardingSkip &&
                      !user.isStepCompleted &&
                      pendingPage.length
                    ) {
                      e.preventDefault();
                    }
                    setShow();
                  }}
                >
                  <Icon name={item.icon} />
                  <span className="ml-3 ">{item.name}</span>
                  {item.name === 'Message' && (
                    <span className="ml-3 inline-flex h-2 w-2 items-center justify-center rounded-full bg-[#FF6600] p-2 text-[10px] font-normal text-white">
                      9
                    </span>
                  )}
                </Link>
              </li>
            ))}

            <div className="h-9"></div>
            <li
              className={`px-4 text-sm ${
                determinePathName(pathname) === 'will-summary'
                  ? 'border-l-4 border-[#FFFFFF] bg-gradient-to-r from-[#FF6600] p-2 font-semibold'
                  : 'font-normal hover:bg-gray-700'
              } `}
            >
              <Link
                to="/dashboard/will-summary"
                className="group  flex items-center  rounded-lg border border-white p-2 text-white"
              >
                <Icon name={Icons.Will} />
                <span className="ml-3 ">Will Summary</span>
              </Link>
            </li>

            {/* <li className={`ml-3 w-48 px-4 pt-14 text-sm font-normal`}>
              <a
                href=""
                className="group flex items-center rounded-lg text-white"
              >
                <Icon name={Icons.Call} />
                <span className="ml-3 ">Contact Lawyer</span>
              </a>
            </li> */}
          </ul>
          <div className="relative bottom-0 mt-12 px-4 pt-10">
            <div className="absolute left-1/2 top-10 z-10 -mt-6 -translate-x-1/2 rounded-3xl bg-white p-5">
              <Icon name={Icons.QuickTips} />
            </div>
            <div className="relative rounded-xl bg-[#0052CC] bg-opacity-[30%] p-4 text-center">
              <div className="mt-10 px-2">
                <p className="text-base font-normal text-white">
                  Next of Kin does not mean Beneficiary
                </p>
                <button className="mt-10 block w-full rounded-md bg-white py-2 text-sm font-medium text-[#FF6600]">
                  Quick Tips
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
